import axios from "axios";
import { API } from "../lib/api";

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("yy_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  cfg.withCredentials = true;
  return cfg;
});

export const formatApiError = (detail) => {
  if (detail == null) return "Bir hata oluştu. Tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
